import { render } from "./ArchiveContracts.vue?vue&type=template&id=edf6b4de&scoped=true&ts=true"
import script from "./ArchiveContracts.vue?vue&type=script&lang=ts"
export * from "./ArchiveContracts.vue?vue&type=script&lang=ts"

import "./ArchiveContracts.vue?vue&type=style&index=0&id=edf6b4de&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf6b4de"]])

export default __exports__